import { Textarea, Text, FormErrorMessage } from '@chakra-ui/core'
import { StyledFormControl, StyledFormLabel } from 'components/AdminConsole/commonUI/styles'
import { useFormContext } from 'react-hook-form'
import React from 'react'
import useLocaleText from 'components/useLocaleText'
import { Bot } from 'lucide-react'

export const PromptField = () => {
  const { register, errors } = useFormContext()
  const t_label = useLocaleText('prompt', true)
  const t_placeholder = useLocaleText('prompt_placeholder', true)
  const validation_rule_is_required = useLocaleText('validation_rule_is_required', true)
  const error = errors.prompt

  return (
    <StyledFormControl isInvalid={!!error}>
      <StyledFormLabel required>
        <Bot size={18} strokeWidth={2.5} />
        <Text>{t_label}</Text>
      </StyledFormLabel>

      <Textarea
        name="prompt"
        ref={register({ required: validation_rule_is_required })}
        minH={{ base: '120px', md: '200px' }}
        borderRadius="5px"
        bg="white"
        resize="none"
        border="1px solid"
        placeholder={t_placeholder}
        _focus={{ boxShadow: '0px 0px 0px 1px black' }}
      />
      <FormErrorMessage>{error?.message}</FormErrorMessage>
    </StyledFormControl>
  )
}
